<div class="row">
  <div class="col-12">
    <div class="d-flex">
      <bdg-text-avatar labelType="subheading-1" [text]="matriculado?.nome"></bdg-text-avatar>
      <div class="d-flex flex-column ml-3">
        <bdg-label class="ml-1" type="title"> {{ matriculado?.nome }} </bdg-label>
        <bdg-info-label class="ml-1" label="CPF" direction="horizontal">{{ matriculado?.cpf | cpf }} </bdg-info-label>
        <div class="d-flex flex-wrap">
          <bdg-tag accent="gray" *ngIf="canShowAnoResidencia()">{{ matriculado?.anoResidencia?.descricao }}</bdg-tag>
          <bdg-tag
            *ngIf="matriculado?.situacaoMatricula"
            [accent]="getSituacaoResidenteAccent(matriculado?.situacaoMatricula)"
            >{{ matriculado?.situacaoMatricula?.descricao }}</bdg-tag
          >
        </div>
      </div>
    </div>
  </div>
</div>
